import { useState } from "react";

import {
  AccountPasswordLoginForm,
  AccountPasswordLoginFormState,
} from "auth/components/AccountPasswordLoginForm";
import { QuickLogin } from "auth/components/QuickLogin";
import { EnvironmentBanner } from "components/EnvironmentBanner/EnvironmentBanner";
import { PublicScreenWrapper } from "components/PublicScreenWrapper/PublicScreenWrapper";
import { useTranslation } from "i18n";

export const Login = ({
  showPasswordLogin = true,
}: {
  showPasswordLogin?: boolean;
}) => {
  const t = useTranslation();
  const [passwordLoginFormState, setPasswordLoginFormState] =
    useState<AccountPasswordLoginFormState>({ step: "CREDENTIALS_FORM" });

  // Hide the rest of the layout if the password login form is past the initial step.
  if (showPasswordLogin && passwordLoginFormState.step !== "CREDENTIALS_FORM") {
    return (
      <PublicScreenWrapper>
        <EnvironmentBanner />

        <div className="flex-col w-full max-w-400">
          <AccountPasswordLoginForm
            state={passwordLoginFormState}
            onStateChange={setPasswordLoginFormState}
          />
        </div>
      </PublicScreenWrapper>
    );
  }

  return (
    <PublicScreenWrapper>
      <EnvironmentBanner />

      <div className="flex-col w-full max-w-400">
        <div className="text-36 font-bold text-center text-primary-dark">
          {t("login.title")}
        </div>
        <div className="text-18 text-center mb-24">
          Nabla Core API Developer Console
        </div>

        <AccountPasswordLoginForm
          state={passwordLoginFormState}
          onStateChange={setPasswordLoginFormState}
        />

        {process.env.VITE_NABLA_USER && (
          <>
            <p className="my-22 text-center">{t("login.or")}</p>
            <QuickLogin />
          </>
        )}

        <div className="rounded border border-grey-100 bg-grey-50 p-12 text-14 leading-20 text-extension-grey-3 mt-40">
          Not here to set up an API integration? If you&apos;re a healthcare
          provider looking to use Nabla&apos;s app, sign in at{" "}
          <a
            className="link"
            href="https://app.nabla.com"
            target="_blank"
            rel="noreferrer"
          >
            app.nabla.com
          </a>{" "}
          instead.
        </div>
      </div>
    </PublicScreenWrapper>
  );
};
